import { Box } from "@biblioteksentralen/react";
import { SanityImageWithResponsiveSize } from "../images/SanityImageWithResponsiveSize";
import { EventStatusBadge } from "./EventStatus";
import { ResolvedEvent } from "@libry-content/common";

const EventImageWithStatusBadge = ({ event }: { event: ResolvedEvent }) => {
  return (
    <Box position="relative">
      <SanityImageWithResponsiveSize
        image={event.image}
        aspectRatio={9 / 5}
        resolution={{ base: 540, sm: 1080, lg: 2160 }}
      />
      <EventStatusBadge event={event} fontSize={{ base: "1xl", sm: "2xl", md: "3xl" }} />
    </Box>
  );
};

export default EventImageWithStatusBadge;
